import React from 'react';
import { T } from '../constants';
import { fmtTime } from '../helpers';
import SystemBadge from './badges/SystemBadge';

export default function PerSystemPanel({ perSystem }) {
  if (!perSystem) return null;
  return (
    <div className="mini-panel">
      <div className="mini-panel-title">Systems</div>
      <div className="mini-panel-body">
        {Object.entries(perSystem).map(([sysId, info]) => (
          <div key={sysId} className="mini-row">
            <SystemBadge systemId={sysId} />
            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
              <span className="mono" style={{ fontWeight: 700, fontSize: 12, color: T.text }}>{info.count}</span>
              {info.last_signal_ts && (
                <span className="mono" style={{ fontSize: 10, color: T.textMuted }}>{fmtTime(info.last_signal_ts)}</span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
